import React, { useEffect } from "react";
import ThemeTitle from "../../components/shared/themeTitle";
import socialIcons from "../../configs/socialConfig";
import pp2 from "../../assets/imgs/pp2.jpg";
import { skills, experience, education } from "../../db/about";

import { toTop } from "../../services/commonFunctions";
import SocialMediaIcon from "../../components/shared/SocialMediaIcon";
import Education from "./Exucation";
import Experience from "./Experience";
import Skill from "./Skill";

/**
 * AboutPage Component
 */
const AboutPage = () => {
  useEffect(() => {
    toTop();
  }, []);

  return (
    <div className="container mt-4">
      {/* About */}
      <div className="about mb-5">
        <ThemeTitle whiteColor="ABOUT" primaryColor="ME" />
        <div className="row">
          <div className="col-lg-4 mb-3 mb-lg-0">
            <img className="img-fluid" src={pp2} alt="Youssef Zidan" />
          </div>
          <div className="col-lg-8">
            <h2 className="text-primary font-weight-bold">Who Am I ?</h2>
            <div className="border-bottom mb-3">
              <p className="text-white">
                Learning is what I do and it’s what I’m good at
                <span role="img" aria-label="nerd face">
                  🤓
                </span>
                .
                <br />
                <br />
                It was a challenge to find my passion during my life journey, So what I did is
                self-learning a lot of skills in many different fields. I started with Graphic
                Applications such as Photoshop and Illustrator.
                <br />
                <br />
                Then I started learning Web Design (UI / UX), And finally, I was curious about how a
                Website actually can be made!
                <span role="img" aria-label="thinking face">
                  🤔
                </span>
                <br />
                <br />
                And this is how I finally found that Web Development is the skill that fulfilled my
                passion
                <span role="img" aria-label="flexed biceps">
                  💪
                </span>
                and let me seeking to build a web Development career.
              </p>
              <div className="d-flex text-primary mb-4">
                {socialIcons.map((icon) => (
                  <React.Fragment key={icon.href}>
                    <SocialMediaIcon icon={icon} />
                  </React.Fragment>
                ))}
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <p>
                  <span className="text-light-gray">Name:</span>{" "}
                  <span className="text-white">Youssef Zidan</span>
                </p>
              </div>
              <div className="col-lg-6">
                <p>
                  <span className="text-light-gray">Email:</span>{" "}
                  <span className="text-white">
                    <a href="mailto:youssefzidan2200@gmail.com">youssefzidan2200@gmail.com</a>
                  </span>
                </p>
              </div>

              <div className="col-lg-6">
                <p>
                  <span className="text-light-gray">Phone:</span>{" "}
                  <span className="text-white">
                    <a href="tel:+2001146264452">(+20) 0114 626 44 52</a>
                  </span>
                </p>
              </div>
            </div>
            <div className="download mt-3">
              <a
                href="https://docs.google.com/document/d/13eKs-o-sRkEpVllyJV90XSme_3v-clsT5i_VtLaukj4/edit?usp=sharing"
                target="blank"
                className="btn btn-primary rounded-pill font-weight-bold w-100"
              >
                DOWNLOAD CV
                <i className="fas fa-download ml-3"></i>
              </a>
            </div>
          </div>
          <div className="col-lg-4"></div>
        </div>
      </div>
      <hr />
      <hr />
      <hr />
      {/* Skills */}
      <div className="skills">
        <h2 className="text-white text-center font-weight-bold mb-5">MY SKILLS</h2>
        <div className="d-flex flex-wrap">
          {skills.map((skill) => (
            <div className="m-2" key={skill.skillName}>
              <Skill skill={skill} />
            </div>
          ))}
        </div>
      </div>
      {/* Experience */}
      <hr />
      <hr />
      <hr />
      <div className="experience">
        <h2 className="text-white text-center font-weight-bold mb-5">EXPERIENCE & EDUCATION</h2>
        <div className="row">
          {/* Experience */}
          <div className="col-lg-6">
            {experience.map((exp) => (
              <Experience exp={exp} />
            ))}
          </div>

          {/* Education */}
          <div className="col-lg-6">
            {education.map((edu) => (
              <Education edu={edu} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
